import { httpClient, ApiResponse } from '@/utils';
import {
  IApproveSuggestedFaqDTO,
  IApproveSuggestedFaqResponse,
  IRejectSuggestedFaqDTO,
  IGetSuggestedFaqsDTO,
  IGetSuggestedFaqsResponse,
  ISuggestedFaqDetails,
  IGetSuggestedFaqByIdDTO,
  getSuggestedFaqEndpoints,
  staticSuggestedFaqEndpoints,
} from '@/models/suggestedFaq.model';

class SuggestedFaqAPI {
  static getSuggestedFaqs(params: IGetSuggestedFaqsDTO): ApiResponse<IGetSuggestedFaqsResponse> {
    const { GET_SUGGESTED_FAQS } = staticSuggestedFaqEndpoints;
    return httpClient.get<IGetSuggestedFaqsResponse>(GET_SUGGESTED_FAQS, { params });
  }

  static getSuggestedFaqById({ reviewId }: IGetSuggestedFaqByIdDTO): ApiResponse<ISuggestedFaqDetails> {
    const { GET_SUGGESTED_FAQ_BY_ID } = getSuggestedFaqEndpoints({ reviewId });
    return httpClient.get<ISuggestedFaqDetails>(GET_SUGGESTED_FAQ_BY_ID);
  }

  static approveSuggestedFaq({
    reviewId,
    ...data
  }: IApproveSuggestedFaqDTO): ApiResponse<IApproveSuggestedFaqResponse> {
    const { APPROVE_SUGGESTED_FAQ } = getSuggestedFaqEndpoints({ reviewId });
    return httpClient.post<IApproveSuggestedFaqResponse>(APPROVE_SUGGESTED_FAQ, data);
  }

  static rejectSuggestedFaq({ reviewId, ...data }: IRejectSuggestedFaqDTO): ApiResponse<ISuggestedFaqDetails> {
    const { REJECT_SUGGESTED_FAQ } = getSuggestedFaqEndpoints({ reviewId });
    return httpClient.post<ISuggestedFaqDetails>(REJECT_SUGGESTED_FAQ, data);
  }
}

export default SuggestedFaqAPI;
